const ibanField = document.querySelector<HTMLInputElement>('#iban');
const bicField = document.querySelector<HTMLInputElement>('#bic');

type KnownBanks = Record<string, readonly [string, string]>;

const knownBanks: Record<string, KnownBanks> = {
	// prettier-ignore
	de: {
		'31251220': ['WELA DE D1 ERK', 'ksk.svg'] as const,
		'37069412': ['GENO DE D1 HRB', 'raiba.svg'] as const,
		'31060517': ['GENO DE D1 MRB', 'raiba.svg'] as const,
	},
	nl: {
		rabo: ['RABO NL 2U', 'rabo.svg'] as const,
	},
};

function resetBicField() {
	const bicResult = document.querySelector<HTMLOutputElement>('#bic-output');
	if (bicResult) {
		bicResult.remove();
	}

	if (bicField) {
		bicField.type = 'text';
		if (bicField.dataset.autofilled === 'true') {
			bicField.value = '';
			bicField.dataset.autofilled = 'false';
		}
	}
}

// Autofill the BIC field by known bank numbers in an IBAN.
if (ibanField && bicField) {
	ibanField.addEventListener('input', () => {
		const iban = ibanField.value;
		const condensedIban = iban.toLowerCase().replaceAll(/\s*/gu, '');

		if (condensedIban.length >= 2) {
			let prefilledBic;
			const countryCode = condensedIban.slice(0, 2);

			if (countryCode === 'nl') {
				const part = condensedIban.slice(4, 8);
				prefilledBic = knownBanks.nl[part];
			} else if (countryCode === 'de') {
				const part = condensedIban.slice(4, 12);
				prefilledBic = knownBanks.de[part];
			}

			if (prefilledBic === undefined) {
				resetBicField();
			} else {
				const [prettyBic, bankLogo] = prefilledBic;

				const bicResult = document.querySelector('#bic-output');
				if (!bicResult) {
					const output = `<output id="bic-output" readonly><img src="/assets/img/logos/${bankLogo}" alt="" style="height: 22px"> ${prettyBic} <i>(automatisch ausgefüllt)</i></output>`;
					bicField.insertAdjacentHTML('beforebegin', output);
				}

				const condensedBic = prettyBic.replaceAll(/\s*/gu, '');
				bicField.value = condensedBic;
				bicField.type = 'hidden';
				bicField.dataset.autofilled = 'true';
			}
		} else {
			resetBicField();
		}
	});
}
